import { render } from "./IconBack.vue?vue&type=template&id=556a227a"
import script from "./IconBack.vue?vue&type=script&lang=js"
export * from "./IconBack.vue?vue&type=script&lang=js"

import exportComponent from "M:\\2. Work\\02. Erachain\\Sidechain\\Репозиторий\\eralauncher-webpack\\eralauncher\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__